import { PropsWithChildren } from 'react'

import { OneOnOnesContextDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useIsBecome } from 'modules/core/lib/useIsBecome'

import { MeetingBecomeErrorLayout } from 'modules/meetings/components/Layout/MeetingBecomeErrorLayout'
import { OneOnOnesContext } from 'modules/meetings/lib/context/OneOnOnesContext'

export const OneOnOnesContextProvider = ({ children }: PropsWithChildren) => {
  const { data, loading } = useQuery(OneOnOnesContextDocument)
  const isBecome = useIsBecome()

  const canSeeMeetings = data?.meetings._policies.seeMeetings.can ?? false
  const canSeeAdvancedMeetings = data?.meetings._policies.seeAdvancedMeetings.can ?? false

  const value = {
    canSeeMeetings,
    canSeeAdvancedMeetings,
    isBecome,
    loading,
  }

  if (isBecome) {
    return <MeetingBecomeErrorLayout />
  }

  return <OneOnOnesContext.Provider value={value}>{children}</OneOnOnesContext.Provider>
}
